<template>
    <div class="main-content" id="panel">
        <div class="header bg-primary pb-6">
            <div class="container-fluid">
            <div class="header-body">
                <div class="row align-items-center py-4">
                    <div class="col-lg-6 col-md-12 col-2 mb-3">
                    <h2>Trade Files</h2>
                    <nav aria-label="breadcrumb" class="d-none d-md-inline-block">
                        <ol class="breadcrumb breadcrumb-links breadcrumb-dark">
                        <li class="breadcrumb-item cursor-pointer" @click="getFiles()" >
                            <i class="fas fa-home"></i>
                        </li>
                        <li class="breadcrumb-item cursor-pointer">{{ menuName }}</li>
                        </ol>
                    </nav>
                    </div>
                    <div class="col-lg-6 col-md-12 col-2 text-right" v-if="!isFolderView">
                       <form @submit.prevent="" class="d-inline-block justify-content-center headSearch mr-5">
                        <i @click="getTradeFilesFromDate(menuName)"  class="fas fa-search active cursor-pointer" aria-hidden="true"></i>
                        <input v-on:keyup.enter="getTradeFilesFromDate(menuName)" v-model.trim="searchText"  @keypress="isAlphanumeric($event)" class="form-control form-control-sm" type="text" placeholder="Search" aria-label="Search">
                        <i v-if="searchText" @click="clearSearch()" class="fas fa-times-circle cursor-pointer"></i>
                        </form>
                        <button class="btn btn-success" @click="downloadAll">Download All</button>
                        <button class="btn btn-info" @click="processFiles">Process</button>
                    </div>
                </div>
                
            </div>
            </div>
        </div>
        <div class="container-fluid mt--6" >
            <div class="row">
                 <div class="col-xl-12">
                    <div class="card vh-75" id="scroll"  v-if="isFolderView">
                        <div class="table-responsive" style="min-height:200px">
                        <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
                        <!-- {{ currentPreFixName }} -->
                        <table class="table align-items-center table-flush table-hover bidtbl" style="min-height:125px">
                            <thead class="thead-light psticky">
                            <tr>
                                <th 
                                    scope="col" 
                                    class="sort"
                                     >Name</th>                  
                            </tr>
                            </thead>
                            <tbody class="list no-cursor">
                            <tr v-if="filesList.length == 0 && !loading">
                                <td><p class="nodata">No data available</p>
                                </td>
                            </tr>
                            <tr v-for="data in filesList" :key="data.id">
                                <td v-if="data.Prefix" class="text-primary cursor-pointer" @click="getTradeFilesFromDate(data.PrefixDisplayName)">
                                    <i class="fas fa-folder-open"></i><span class="object-name">{{data.PrefixDisplayName}}</span>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        <div class="total-records">
                            <span>Total Records : {{filesList.length}}</span>
                        </div> 
                        </div>
                    </div>
                    <div class="col-xl-12" >
                      <div class="card vh-75" id="scroll" v-if="!isFolderView">
                        <div class="table-responsive" style="min-height:200px">
                          <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
                          <table class="table align-items-center table-flush table-hover bidtbl" style="min-height:125px">
                            <thead class="thead-light psticky">
                              <tr>
                                <th scope="col" class="sort">sender</th>
                                <th scope="col" class="sort">subject</th>
                                <th scope="col" class="sort">received at</th>
                                <th scope="col" class="sort">action </th>
                              </tr>
                            </thead>
                            <tbody class="list no-cursor">
                              <tr v-if="tradeFiles.length == 0 && !loading">
                                <td><p class="nodata">No data available</p></td>
                              </tr>
                              <tr v-for="data in tradeFiles" :key="data.id">
                                <td>{{data.sender}}</td>
                                <td>{{data.subject}}</td>
                                <td>{{data.receivedUtc ? moment(data.receivedUtc).format('YYYY-MM-DD HH:mm:ss') : ''}}</td>
                                <td>
                                  <button class="btn btn-primary btn-sm" @click="getTradeFilesFromMessageID(data)">
                                    <i class="fas fa-folder-open"></i> Files
                                  </button>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                          <div>
                              <b-pagination
                                    class="mt-4"
                                    :total-rows="totalRows"
                                    v-model="currentPage"
                                    :per-page="perPage"
                                    @input="getTradeFilesFromDate(menuName)"
                                    ></b-pagination>
                                <div class="total-records">
                                    <span>Total Records : {{totalRows}}</span>
                                </div>
                          </div>
                        </div>
                      </div>
                    </div>
                     <div
                        class="modal fade"
                        id="exportmodal"
                        tabindex="-1"
                        role="dialog"
                        aria-labelledby="exampleModalLabel"
                        aria-hidden="true"
                    >
                        <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                              <div class="d-flex flex-column" style="padding: 16px 0;">
                                <h4 class="modal-title" style="font-weight: 700; color: #0073bb; letter-spacing: 1px; margin-bottom: 6px;">
                                  <i class="fas fa-user" style="margin-right: 8px; color: #0073bb;"></i>
                                  From: <span style="color: #333;">{{selectedSender ? selectedSender.sender : ''}}</span>
                                </h4>
                                <h4 class="modal-title" style="font-weight: 500; color: rgb(0, 115, 187); margin-top: 2px;">
                                  <i class="fas fa-envelope" style="margin-right: 8px; color: #0073bb;"></i>
                                  Subject: <span style="color: #555;"> {{selectedSender ? selectedSender.subject : ''}}</span>
                                </h4>
                              </div>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                            </div>
                            <div class="modal-body">
                                 <div class="table-responsive" style="min-height:200px">
                          <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
                          <table class="table align-items-center table-flush table-hover bidtbl" style="min-height:125px">
                            <thead class="thead-light psticky">
                              <tr>
                                <th scope="col" class="sort">file name</th>
                                <th scope="col" class="sort">action </th>
                              </tr>
                            </thead>
                            <tbody class="list no-cursor">
                              <tr v-if="filesfromMessageId.length == 0 && !loading">
                                <td><p class="nodata">No data available</p></td>
                              </tr>
                              <tr v-for="data in filesfromMessageId" :key="data.id">
                                <td>{{data.name}}</td>
                                <td>
                                  <button :disabled="data.isRemoved" class="btn btn-success btn-sm" @click="downloadFile(data.key)">
                                    <i class="fas fa-download"></i> Download
                                  </button>
                                   <button  class="btn btn-primary btn-sm" @click="downloadFileFromDB(data)">
                                    <i class="fas fa-plus"></i> {{data.isRemoved ? 'ADD BACK' : 'REMOVE'}}
                                  </button>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                         
                        </div>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>      
</template>
<script>
import AWS from 'aws-sdk/global';
import config from "@/config";
import authService from "@/authService";

export default {
  name: "unprocessed",
  components : {
    
  },
  data() {
    return {
        filesList : [],
        accessToken : null,
        loading: false,
        processing : false,
        currentPreFixName : "ticket_catalogue/catalogue/",
        navMenus : [],
        tradeFiles : [],
        isFolderView: true,
        menuName: "",
        filesfromMessageId: [],
        selectedSender: null,
        totalRows: 0,
        currentPage: 1,
        perPage: 25,
        searchText: "",


    };
  },
  methods: {
    clearSearch() {
      this.searchText = "";
      this.getTradeFilesFromDate(this.menuName);
    },

    downloadAll() {
      this.loading = true;
      const auth = {
        headers: {'org-token' : authService.getOrgToken() }
      };
      this.$http
        .get(
           config.baseUrlAutoBidder + "/ticket-catalogue/trade-files/zip?ticketDate="+this.menuName.replace('/', '')+"&cognitoSub="+authService.getUser().cognitoSub,
            auth
        )
        .then((response) => {
          this.$alert(response.data.message, "", "success");
          this.loading = false;
        })
        .catch(e => {
          console.log(e);
          //Error Occured so forcefully logged out 
          this.loading = false;

        });
    },
    processFiles() {
      this.loading = true;
      const auth = {
        headers: {'org-token' : authService.getOrgToken() }
      };
      let data = {
        "mode": "PROCESS",
        "cognitoSub": authService.getUser().cognitoSub,
        "source": "outlook_email_fetcher/attachments/" + this.menuName.replace('/', ''),
        "ticketDate": this.menuName.replace('/', '')
      };
      this.$http
        .post(
           config.baseUrlBidSide + "/ticket-catalogue/process",
            data,
            auth
        )
        .then((response) => {
          this.$alert(response.data.message, "", "success");
          this.loading = false;
        })
        .catch(e => {
          console.log(e);
          //Error Occured so forcefully logged out 
          this.loading = false;

        });
    },

    menuClicked(currentMenu){
        //console.log(this.currentPreFixName.split(currentMenu))
        let path = this.currentPreFixName.split("/"+currentMenu)[0]+"/"+currentMenu+"/";
        console.log(path)
        this.getFiles(path);
    },
    setNavMenu(){
        let menuString = this.currentPreFixName.split('ticket_catalogue/catalogue/').pop();
        this.navMenus = [];
        this.navMenus = menuString.split("/")
    },
    downloadFileFromDB(data){
      this.loading = true;
      const auth = {
        headers: {'org-token' : authService.getOrgToken() }
      };
      this.$http
        .patch(
           config.baseUrlAutoBidder +
            "/ticket-catalogue/trade-file",{
                "messageId": this.selectedSender.messageId,
                "attachmentId": data.id
            },
            auth
        )
        .then(() => {
            this.$alert("File " + (data.isRemoved ? "added back" : "removed") + " successfully","","success");
            this.loading = false;
            this.getTradeFilesFromMessageID(this.selectedSender);
        })
        .catch(e => {
          console.log(e);
          //Error Occured so forcefully logged out 
          this.loading = false;

        });
    },
    downloadFile(downloadKey){
      this.loading = true;
      const auth = {
        headers: {'org-token' : authService.getOrgToken() }
      };
      this.$http
        .post(
           config.baseUrlBidSide +
            "/fileupload/get-file",{
                    "key":downloadKey
                },
            auth
        )
        .then((response) => {
          window.open(response.data, "_blank");
          this.loading = false;
        })
        .catch(e => {
          console.log(e);
          //Error Occured so forcefully logged out 
          this.loading = false;

        });
    },
    getTradeFilesFromDate(date){
      this.loading = true;
      const auth = {
        headers: {'org-token' : authService.getOrgToken() }
      };
      this.menuName = date;
      this.$http
        .get(
           config.baseUrlAutoBidder + "/ticket-catalogue/trade-emails?page=" + this.currentPage + "&size=" + this.perPage + "&ticketDate=" + date.replace('/', "") + "&search=" + this.searchText,
            auth
        )
        .then((response) => {
            this.tradeFiles = response.data.content;
            this.totalRows = response.data.pageInfo.totalElements;

            this.isFolderView = false;
            console.log(response.data);
          this.loading = false;
        })
        .catch(e => {
          console.log(e);
          //Error Occured so forcefully logged out 
          this.loading = false;

        });
    },
    getTradeFilesFromMessageID(senderData){
      this.loading = true;
      this.selectedSender = senderData;
      const auth = {
        headers: {'org-token' : authService.getOrgToken() }
      };
      let data = {
            "messageId": this.selectedSender.messageId
        };
      this.$http
        .post(
           config.baseUrlAutoBidder + "/ticket-catalogue/trade-files",
            data,
            auth
        )
        .then((response) => {
            this.filesfromMessageId = response.data;
            window.$('#exportmodal').modal("show");

           console.log(response.data)
           this.loading = false;
        })
        .catch(e => {
          console.log(e);
          //Error Occured so forcefully logged out 
          this.loading = false;

        });
    },
    getFiles(preFixName){
        this.isFolderView = true;
        let self = this;
        var s3 = new AWS.S3({
            apiVersion: "2006-03-01",
            params: { Bucket: "imsfileupload"}
        });
        if(preFixName){
            this.currentPreFixName = preFixName;
        }else{
            this.currentPreFixName = "outlook_email_fetcher/attachments/";
        }
        this.setNavMenu();
        var params = {
            Bucket: config.albumBucketNameIms, /* required */
            Prefix: this.currentPreFixName,  
            Delimiter: '/'
        };
        self.loading = true
        s3.listObjectsV2(params, function(err, data) {
            if (err) {
                self.$alert("File upload session expired. Please try again.","","error").then(() => {
                    window.location.reload()
                })
                console.log(err, err.stack);self.loading = false
            } // an error occurred
            else {
                
                if(data.CommonPrefixes.length > 0){
                    let outPut = [];
                     data.CommonPrefixes.forEach(element => {
                        element.PrefixDisplayName = element.Prefix.split(self.currentPreFixName).pop();
                        outPut.push(element)
                    });
                    self.filesList = outPut;
                }
                if(data.Contents.length > 0){
                    let outPut = [];
                     data.Contents.forEach(element => {
                        element.KeyDisplayName = element.Key.split(self.currentPreFixName).pop();
                        outPut.push(element)
                    });
                    self.filesList = outPut;
                }
                self.loading = false

            }     
        });
    }
   
  },
  mounted() {
      this.loading = true;
      let self = this;
      this.$cognitoAuth.getIdToken((err, result) => {
          if (err) {
              console.log("accessToken is not found", err);
          } else {
              this.accessToken = result;
          }
      });
      const userPoolLoginKey = config.userPoolLoginKey;
      const logins = {};
      logins[userPoolLoginKey] = this.accessToken;
      AWS.config.region = config.region;
      const cognitoParams = {
          IdentityPoolId: config.IdentityPoolIdFileUpload,
          Logins: logins
      };
      let cognitoidentity = new AWS.CognitoIdentity();
      cognitoidentity.getId(cognitoParams, function(err, data) {
          if (err) {
              console.log(err);
              self.$alert("File upload session expired. Please try again.","","error").then(() => {
                    window.location.reload()
                })
          } else {
              console.log(data.IdentityId);
              let bucketRegion = AWS.config.region;
              AWS.config.update({
              region: bucketRegion,
              credentials: new AWS.CognitoIdentityCredentials(cognitoParams)
              });
              self.getFiles();
          }
      });
      
    }
};
</script>
<style scoped>
.table i{
    color: #0073bbc7;

}
.modal i {
    font-size: 12px !important;
}
.object-name{
    padding: 7px;
    font-size: 13px;
    color: #0073bbc7;
}
</style>